import axios from 'axios';

const QUEUE_KEY = 'wffa_offline_vote_queue';

/**
 * Offline Vote Queue
 * Stores votes in localStorage when offline, sends them when back online.
 */

const getQueue = () => {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch { return []; }
};

const saveQueue = (queue) => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue));
};

export const enqueueVote = (voteData) => {
  const queue = getQueue();
  queue.push({ ...voteData, queuedAt: Date.now() });
  saveQueue(queue);
};

export const getQueueLength = () => getQueue().length;

export const flushQueue = async () => {
  const queue = getQueue();
  if (queue.length === 0) return { sent: 0, failed: 0 };

  let sent = 0;
  let failed = 0;
  const remaining = [];

  for (const vote of queue) {
    try {
      if (vote.type === 'battle') {
        await axios.post(vote.url, {
          judge_id: vote.judge_id,
          athlete1_score: vote.athlete1_score,
          athlete2_score: vote.athlete2_score,
        });
      } else if (vote.type === 'circle') {
        await axios.post(vote.url, {
          judge_id: vote.judge_id,
          scores: vote.scores,
        });
      }
      sent++;
    } catch {
      // If it's an old vote (>5 min), discard it
      if (Date.now() - vote.queuedAt > 5 * 60 * 1000) {
        failed++;
      } else {
        remaining.push(vote);
      }
    }
  }

  saveQueue(remaining);
  return { sent, failed };
};

// Auto-flush on reconnect
if (typeof window !== 'undefined') {
  window.addEventListener('online', () => {
    flushQueue();
  });
}
